@if (field()?.typedControl()?.enabled) {
  <div *transloco="let t" class="field-wrapper mt-2" [class.invalid]="field()?.typedControl().invalid">
    @if(!!field()?.label() && !!field()?.showLabel()) {
      <label [for]="field()?.fieldId">
        {{ field()?.label() }}
        @if (field()?.optional()) {
          <span class="optional-label">({{ t('form.optional') }})</span>
        }
      </label>
    }
    @if(field()?.description()) {
      <p class="field-description">
        {{ field()?.description() }}
      </p>
    }

    <ng-content></ng-content>
    @if (errors().length > 0) {
      <div class="invalid-feedback">
        @for (error of field()?.errors(); track error.key; let isLast = $last) {
          <ng-container>{{ t('form.error.' + error.key) }}<br *ngIf="!isLast"/></ng-container>
        }
      </div>
    }
  </div>
}

